module.exports = __webpack_public_path__ + "static/img/p6.1487b7c7.png";